import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { twMerge } from 'tailwind-merge';

/**
 * 더리스닝 Header Bar
 * - createPortal을 사용해 id="listening-header" 엘리먼트에 렌더링
 * - 사이드바 오른쪽에 위치, 높이만 확보 (내용은 페이지별로 채움)
 * - 페이지별 내용은 children으로 받음
 */
const ListeningHeader = observer(
    ({ children, className }: { children?: React.ReactNode; className?: string }) => {
        const [container, setContainer] = useState<HTMLElement | null>(null);

        useEffect(() => {
            setContainer(document.getElementById('listening-header'));
        }, []);

        if (!container) {
            return null;
        }

        return createPortal(
            <header
                className={twMerge(
                    'bg-base-100 relative w-full',
                    'flex flex-row pr-4',
                    // 높이는 변수로 처리하는데, ListeningLayout 에서 너비에 따라 다르게 처리함
                    'h-(--listening-header-height)',
                    // 모바일에서는 sidebar 영역만큼을 왼쪽 여백을 줌
                    'items-center pl-10',
                    // 큰 화면에서는 상단 여백을 줌
                    'md:items-end md:pl-4',
                    className,
                )}
            >
                {children}
                {import.meta.env.DEV && (
                    <div
                        // DEV 표시
                        className="pointer-events-none absolute top-0.5 right-0.5 font-bold text-red-400"
                        style={{ fontSize: '10px' }}
                    >
                        DEV
                    </div>
                )}
            </header>,
            container,
        );
    },
);

export default ListeningHeader;
